<template>
  <div>
    <div class="title-h3 title-bar">구성 정보</div>
    <hr class="mr-b20">
    <el-row v-loading="isLoading" type="flex" justify="space-between" :gutter="20" class="mr-t5">
      <el-col :span="24">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">기본 정보</div>
              <div class="list form-list">
                <el-form ref="configForm" :model="formData" label-width="120px" :rules="configRules">
                  <el-form-item label="장비명">
                    <w-text-form :modifiable="modifiable" :target="formData" property="objName">
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="IP 종류">
                    <w-select-form :modifiable="modifiable" :target="formData" :option-list="iptypeList" option-key="ipaddressApplytype" property="ipaddressApplytype" labelprop="label">
                    </w-select-form>
                  </el-form-item>
                  <el-form-item label="IPv4" prop="ipaddressIpv4">
                    <w-text-form :modifiable="modifiable" :target="formData" property="ipaddressIpv4">
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="IPv6" prop="ipaddressIpv6">
                    <w-text-form :modifiable="modifiable" :target="formData" property="ipaddressIpv6">
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="서브넷마스크">
                    <w-text-form :modifiable="modifiable" :target="formData" property="objSubnetmask">
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="MAC 주소">
                    <w-text-form :modifiable="modifiable" :target="formData" property="objMacaddress">
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="OS종류">
                    <w-select-form :modifiable="modifiable" :target="formData" :option-list="objTypeList" option-key="label, objtypeName" property="objtypeId" labelprop="objtypeName">
                    </w-select-form>
                  </el-form-item>
                  <el-form-item label="서비스팩">
                    <w-text-form :modifiable="modifiable" :target="formData" property="osServicepackVer">
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="시스템 종류">
                    <w-text-form :modifiable="modifiable" :target="formData" property="osArchtecture">
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="구동시간">
                    <w-text-form :modifiable="false" :target="formData" property="uptime">
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="중요도">
                    <w-obj-importance-form-editor :modifiable="modifiable" :target="formData" property="objImportance">
                    </w-obj-importance-form-editor>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>

            <el-row class="mr-b30">
              <div class="title-h4 title-bar">장비 접속 설정</div>
              <div class="list form-list">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="접속 방법">
                    <w-select-form :modifiable="modifiable" :target="formData" :option-list="connetTypeList" option-key="label" property="useSSH" labelprop="label">
                    </w-select-form>
                  </el-form-item>
                  <el-form-item label="Telnet Port">
                    <w-number-form :modifiable="modifiable" :target="formData" property="telnetPort">
                    </w-number-form>
                  </el-form-item>
                  <el-form-item label="SSH Port">
                    <w-number-form :modifiable="modifiable" :target="formData" property="sshPort">
                    </w-number-form>
                  </el-form-item>
                  <el-form-item label="RDP Port" v-if="formData.objtypeId === 'WINSVR'">
                    <w-number-form :modifiable="modifiable" :target="formData" property="rdpPort">
                    </w-number-form>
                  </el-form-item>
                  <el-form-item label="1차 접속 ID">
                    <w-text-form :modifiable="modifiable" :target="formData" property="telnetuserId1">
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="1차 패스워드">
                    <w-text-form :modifiable="modifiable" :target="formData" property="telnetuserPw1" type="password">
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="2차 접속 ID">
                    <w-text-form :modifiable="modifiable" :target="formData" property="telnetuserId2">
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="2차 패스워드">
                    <w-text-form :modifiable="modifiable" :target="formData" property="telnetuserPw2" type="password">
                    </w-text-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
          </el-col>
          <el-col :span="8">
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">HW/SW 정보</div>
              <div class="list form-list">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="CPU">
                    <w-text-form :modifiable="false" :target="formData" property="cpuLabel">
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="MEM 크기">
                    <w-text-form :modifiable="false" :target="formData" property="memSize">
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="MEM 사용 슬롯 수">
                    <w-text-form :modifiable="false" :target="formData" property="memCnt">
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="DISK 크기">
                    <w-text-form :modifiable="false" :target="formData" property="diskSize">
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="DISK 사용 슬롯 수">
                    <w-text-form :modifiable="false" :target="formData" property="diskCnt">
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="NIC 정보">
                    <span v-html="formData.nicDescStr"></span>
                  </el-form-item>
                  <el-form-item label="S/W 사용 수">
                    <w-text-form :modifiable="false" :target="formData" property="swCnt">
                    </w-text-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">동작 상태 설정</div>
              <div class="list form-list">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="동작상태 감지 방법">
                    <w-checkgroup-form :modifiable="modifiable" :target="formData" :option-list="aliveOptionList">
                    </w-checkgroup-form>
                  </el-form-item>
                  <el-form-item label="에이전트 상태 감지">
                    <w-check-form :modifiable="modifiable" :target="formData" property="sessionCheckFlag">
                    </w-check-form>
                  </el-form-item>
                  <el-form-item label="TCP 포트 감지">
                    <w-number-form :modifiable="modifiable" :target="formData" property="alivecheckTcpPort">
                    </w-number-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">SNMP 설정</div>
              <div class="list form-list">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="커뮤니티 읽기">
                    <w-text-form :modifiable="modifiable" :target="formData" property="snmpCommunityRead" type="password">
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="커뮤니티 읽기/쓰기">
                    <w-text-form :modifiable="modifiable" :target="formData" property="snmpCommunityReadwrite" type="password">
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="버전">
                    <w-select-form :modifiable="modifiable" :target="formData" :option-list="snmpVersionList" option-key="snmpVersion" property="snmpVersion" labelprop="label">
                    </w-select-form>
                  </el-form-item>
                  <el-form-item label="포트">
                    <w-number-form :modifiable="modifiable" :target="formData" property="snmpPort">
                    </w-number-form>
                  </el-form-item>
                </el-form>
              </div>
              <div v-if="isSnmpv3" class="list form-list">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="USER">
                    <w-text-form :modifiable="modifiable" :target="formData" property="snmpV3Username">
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="Context 명">
                    <w-text-form :modifiable="modifiable" :target="formData" property="snmpV3ContextName">
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="Context ID">
                    <w-text-form :modifiable="modifiable" :target="formData" property="snmpV3ContextId">
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="Auth 프로토콜">
                    <w-select-form @change="authChange" :modifiable="modifiable" :target="formData" :option-list="snmpV3AuthList" option-key="snmpV3AuthProtocol" property="snmpV3AuthProtocol" labelprop="label">
                    </w-select-form>
                  </el-form-item>
                  <el-form-item label="Auth 비밀번호">
                    <w-text-form :modifiable="hasAutoProtocol" :target="formData" property="snmpV3AuthPassword" type="password">
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="Privacy 프로토콜">
                    <w-select-form @change="privChange" :modifiable="modifiable" :target="formData" :option-list="snmpV3PrivList" option-key="snmpV3PrivProtocol" property="snmpV3PrivProtocol" labelprop="label">
                    </w-select-form>
                  </el-form-item>
                  <el-form-item label="Privacy 비밀번호">
                    <w-text-form :modifiable="hasPrivProtocol" :target="formData" property="snmpV3PrivPassword" type="password">
                    </w-text-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
          </el-col>
          <el-col :span="8">
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">관리자/유지보수 정보</div>
              <div class="list form-list">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="관리자(정)">
                    <el-select v-if="modifiable" ref="selectEditor" v-model="formData.objManagerIdMajor" :filterable="true" default-first-option controls-position="right" size="mini" clearable>
                      <el-option v-for="option in managerList" :key="option.managerId" :label="option.mapLabel" :value="option.managerId">
                      </el-option>
                    </el-select>
                    <span v-else> {{getObjManagerName(formData.objManagerIdMajor)}} </span>
                  </el-form-item>
                  <el-form-item label="관리자(부)">
                    <el-select v-if="modifiable" ref="selectEditor" v-model="formData.objManagerIdMinor" :filterable="true" default-first-option controls-position="right" size="mini" clearable>
                      <el-option v-for="option in managerList" :key="option.managerId" :label="option.mapLabel" :value="option.managerId">
                      </el-option>
                    </el-select>
                    <span v-else> {{getObjManagerName(formData.objManagerIdMinor)}} </span>
                  </el-form-item>
                  <el-form-item label="유지보수 업체">
                    <w-text-form :modifiable="modifiable" :target="formData" property="maintenanceCompany">
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="유지보수 담당자">
                    <w-text-form :modifiable="modifiable" :target="formData" property="maintenanceManager">
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="유지보수 연락처">
                    <w-text-form :modifiable="modifiable" :target="formData" property="maintenanceTel">
                    </w-text-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">프로토콜 설정</div>
              <div class="list form-list">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="ICMP 시도횟수">
                    <w-number-form :modifiable="modifiable" :target="formData" property="icmpTrycount">
                    </w-number-form>
                  </el-form-item>
                  <el-form-item label="ICMP 타임아웃(ms)">
                    <w-number-form :modifiable="modifiable" :target="formData" property="icmpTimeout">
                    </w-number-form>
                  </el-form-item>
                  <el-form-item label="ICMP 패킷크기(byte)">
                    <w-number-form :modifiable="modifiable" :target="formData" property="icmpDatasize">
                    </w-number-form>
                  </el-form-item>
                  <el-form-item label="ICMP CLI Ping">
                    <w-check-form :modifiable="modifiable" :target="formData" property="icmpClipingApplyFlag" tf-type="Number">
                    </w-check-form>
                  </el-form-item>
                  <el-form-item label="SNMP 시도횟수">
                    <w-number-form :modifiable="modifiable" :target="formData" property="snmpTrycount">
                    </w-number-form>
                  </el-form-item>
                  <el-form-item label="SNMP 타임아웃(ms)">
                    <w-number-form :modifiable="modifiable" :target="formData" property="snmpTimeout">
                    </w-number-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">Application Link 설정</div>
              <div class="list form-list">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="Link">
                    <w-text-form :modifiable="modifiable" :target="formData" property="linkWwwUrl">
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="Application">
                    <w-text-form :modifiable="modifiable" :target="formData" property="linkAppPath">
                    </w-text-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">이벤트 제외 설정</div>
              <div class="list form-list">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="이벤트 제외">
                    <w-check-form :modifiable="modifiable" :target="formData" property="eventExceptFlag">
                    </w-check-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>

</template>

<script>
import { mapGetters } from 'vuex';
import { isEmpty, isNil, eq, assign } from 'lodash';
import { createEncryptTargetData, getRsaEncrypt } from '@/utils/rsa-encrypt';

// api
import serverInfoAPI from '@/api/config/server/server-info';
import commonAPI from '@/api/config/common';

// for edit cmp
import WTextForm from '@/components/formeditor/TextFormEditor';
import WNumberForm from '@/components/formeditor/NumberFormEditor';
import WSelectForm from '@/components/formeditor/SelectFormEditor';
import WCheckgroupForm from '@/components/formeditor/CheckGroupFormEditor';
import WCheckForm from '@/components/formeditor/CheckFormEditor';
import wManagerTreeForm from '@/components/formeditor/MgrTreeSelectEditor';
import { EMPTY_TEXT } from '@/utils/string';
import { convertValuByUnit } from '@/utils/number';
import MsgUtil from '@/utils/message';
import WObjImportanceFormEditor from '@/components/formeditor/ObjImportanceFormEditor';

const iptypeList = [
  {
    label: 'IPv4',
    ipaddressApplytype: 'IPv4',
  },
  {
    label: 'IPv6',
    ipaddressApplytype: 'IPv6',
  },
];

const connetTypeList = [
  {
    label: 'SSH',
    useSSH: true,
  },
  {
    label: 'Telnet',
    useSSH: false,
  },
];

export default {
  name: 'WConfigStatus',
  props: {
    nodeParams: Object,
    activeTab: String,
  },
  components: {
    serverInfoAPI,
    WTextForm,
    WNumberForm,
    WSelectForm,
    WCheckgroupForm,
    WCheckForm,
    wManagerTreeForm,
    WObjImportanceFormEditor,
  },
  data() {
    return {
      isLoading: true,
      false: false,
      iptypeList,
      connetTypeList,
      objOriginData: {}, // Reject데이터
      formData: {}, // Form 바인딩 데이터
      objTypeList: [],
      managerList: [],
      aliveOptionList: [],
      snmpVersionList: [],
      snmpV3AuthList: [],
      snmpV3PrivList: [],
      basicInfoLoadFlag: false,
    };
  },
  computed: {
    ...mapGetters(['configRules', 'rejectConfigEditing', 'saveConfigEditing']),
    params() {
      return {
        objId: this.nodeParams.objId,
        serverId: this.nodeParams.serverId,
        ciInstanceId: this.nodeParams.ciInstanceId,
      };
    },
    modifiable() {
      return this.$store.state.config.isConfigEditing;
    },
    isSnmpv3() {
      return eq('V3', this.formData.snmpVersion) ? true : this.false;
    },
    hasAutoProtocol() {
      return !eq('NONE', this.formData.snmpV3AuthProtocol) ? this.modifiable : this.false;
    },
    hasPrivProtocol() {
      return !eq('NONE', this.formData.snmpV3PrivProtocol) ? this.modifiable : this.false;
    },
  },
  watch: {
    activeTab: {
      immediate: true,
      handler(tabName) {
        if (tabName === this.$options.name) {
          this.loadData();
        }
      },
    },
    params: {
      immediate: true,
      handler() {
        if (this.modifiable) {
          // 대상 변경 시 수정모드 종료
          this.$store.dispatch('setConfigEditing', false);
        }
        this.loadData();
      },
    },
    rejectConfigEditing: {
      immediate: true,
      handler(to) {
        if (to) {
          this.initAliveChechGroup(this.objOriginData);
          this.formData = Object.assign({}, this.objOriginData);
          this.$store.dispatch('initRejectConfig');
        }
      },
    },
    saveConfigEditing: {
      immediate: true,
      handler(to) {
        if (to) {
          this.$refs.configForm.validate((valid) => {
            if (valid) {
              this.$confirm(...MsgUtil.getBasicConfirmData(MsgUtil.action.SAVE))
                .then(() => {
                  const formData = this.formData;
                  const infoParams = Object.assign({}, formData);
                  const modifiedData = formData.modified;
                  const updateDate = {
                    serverId: infoParams.serverId,
                    objId: infoParams.objId,
                    objName: infoParams.objName,
                    ipaddressApplytype: infoParams.ipaddressApplytype,
                    objCompanyId: infoParams.objCompanyId,
                    objImportance: formData.objImportance, // null이면 delete로 판단하므로 값 변경이 없을 경우에도 서버단에 전달한다.
                  };
                  if (infoParams.ipaddressApplytype === 'IPv4') {
                    updateDate.ipaddressIpv4 = infoParams.ipaddressIpv4;
                  } else if (infoParams.ipaddressApplytype === 'IPv6') {
                    updateDate.ipaddressIpv6 = infoParams.ipaddressIpv4;
                  }
                  if (modifiedData && Object.keys(modifiedData).length > 0) {
                    Object.keys(modifiedData).forEach((key) => {
                      updateDate[key] = formData[key];

                      if (eq('snmpV3AuthProtocol', key) && eq(formData[key], 'NONE')) {
                        updateDate.snmpV3AuthPassword = '';
                      }

                      if (eq('snmpV3PrivProtocol', key) && eq(formData[key], 'NONE')) {
                        updateDate.snmpV3PrivPassword = '';
                      }
                    });
                  }
                  if (this.objOriginData.objManagerIdMajor !== formData.objManagerIdMajor) {
                    updateDate.objManagerIdMajor = formData.objManagerIdMajor;
                  }

                  if (this.objOriginData.objManagerIdMinor !== formData.objManagerIdMinor) {
                    updateDate.objManagerIdMinor = formData.objManagerIdMinor;
                  }

                  const target = '구성 정보';
                  const action = MsgUtil.action.SAVE;
                  const encryptTargetData = createEncryptTargetData(updateDate, ['telnetuserPw1', 'telnetuserPw2', 'snmpCommunityRead', 'snmpCommunityReadwrite', 'snmpV3AuthPassword', 'snmpV3PrivPassword']);
                  if (encryptTargetData !== null) {
                    getRsaEncrypt(encryptTargetData)
                      .then((encryptData) => {
                        this.saveConfig(assign(updateDate, encryptData), action, target);
                      })
                      .catch((e) => {
                        this.$message(MsgUtil.getResultMsgData(action, target, false));
                        throw new Error(e);
                      });
                  } else {
                    this.saveConfig(updateDate, action, target);
                  }
                })
                .catch(() => {
                  this.$store.dispatch('setSaveConfigEditing', false);
                });
            } else {
              this.$store.dispatch('setSaveConfigEditing', false);
            }
          });
        }
      },
    },
  },
  methods: {
    convertValuByUnit,
    loadData() {
      this.isLoading = true;
      if (isNil(this.params.objId)) {
        return;
      }

      // 최초 한번만 호출
      if (!this.basicInfoLoadFlag) {
        this.setBasicInfoData();
      }
      this.objOriginData = {};
      const basicConfig = () =>
        serverInfoAPI.getSmsConfigInfoBasic(this.params).then((result) => {
          if (result.data.success) {
            const data = result.data.data;
            this.initAliveChechGroup(data);

            if (isNil(data.snmpVersion)) {
              data.snmpVersion = 'NONE';
            }

            if (isNil(data.snmpV3AuthProtocol)) {
              data.snmpV3AuthProtocol = 'NONE';
            }

            if (isNil(data.snmpV3PrivProtocol)) {
              data.snmpV3PrivProtocol = 'NONE';
            }

            Object.assign(this.objOriginData, data);
          }
        });
      const hwswConfig = () =>
        serverInfoAPI.getSmsConfigInfoHwsinfo(this.params).then((result) => {
          if (result.data.success) {
            const data = result.data.data;
            const nicDesc = data.nicDesc;
            let nicDescStr = '';
            if (nicDesc) {
              const length = nicDesc.split(',').length;
              nicDesc.split(',').forEach((st, idx) => {
                nicDescStr += st;
                if (length > 1 && idx !== length - 1) nicDescStr += '<br />';
              });
            }
            data.nicDescStr = nicDescStr;
            data.cpuLabel = isNil(data.cpuName) ? EMPTY_TEXT : `${data.cpuName} (${data.cpuCoreCnt})`;
            data.memSize = isNil(data.memTotSize) ? EMPTY_TEXT : `${convertValuByUnit(data.memTotSize, 'Byte', true, false, true)}B`;
            data.diskSize = isNil(data.diskTotSize) ? EMPTY_TEXT : `${convertValuByUnit(data.diskTotSize, 'Byte', true, false, true)}B`;
            Object.assign(this.objOriginData, data);
          }
        });
      Promise.all([basicConfig(), hwswConfig()]).then(() => {
        this.formData = Object.assign({}, this.objOriginData);
        this.$emit('setConfigData', this.formData);
      }).finally(() => {
        this.isLoading = false;
      });
    },
    /**
     * 구성 정보를 저장한다.
     * @author Ju
     * @param  {[type]} updateDate [description]
     * @param  {[type]} action     [description]
     * @param  {[type]} target     [description]
     * @return {[type]}            [description]
     */
    saveConfig(updateDate, action, target) {
      serverInfoAPI
        .updateSmsConfigInfo(updateDate)
        .then((result) => {
          if (result.data.success) {
            this.$message(MsgUtil.getResultMsgData(action, target, true));
            this.$store.dispatch('endConfigEdit');
            this.loadData();
          } else {
            this.$message(MsgUtil.getResultMsgData(action, target, false));
          }
        })
        .catch(() => {
          this.$message(MsgUtil.getResultMsgData(action, target, true));
        });
    },
    initAliveChechGroup(data) {
      const aliveOptionList = [
        {
          key: 'alivecheckFlagSnmp',
          label: 'SNMP',
          value: Number(data.alivecheckFlagSnmp),
        },
        {
          key: 'alivecheckFlagIcmp',
          label: 'ICMP',
          value: Number(data.alivecheckFlagIcmp),
        },
        {
          key: 'alivecheckFlagTcpport',
          label: 'TCP',
          value: Number(data.alivecheckFlagTcpport),
        },
      ];
      this.aliveOptionList = aliveOptionList;
    },
    authChange(value) {
      if (eq('NONE', value)) {
        this.formData.snmpV3AuthPassword = null;
      }
    },
    privChange(value) {
      if (eq('NONE', value)) {
        this.formData.snmpV3PrivPassword = null;
      }
    },
    setBasicInfoData() {
      commonAPI
        .getObjTypeList({
          managetypeId: 'SMS',
        })
        .then((res) => {
          this.objTypeList = res.data.data;
        });
      commonAPI
        .getBasicinfoSubList({
          basicinfoId: 'SNMPVER',
        })
        .then((res) => {
          const list = res.data.data;
          const snmpVersionList = [];

          list.forEach((data) => {
            snmpVersionList.push({
              label: data.basicinfoSubname,
              snmpVersion: data.basicinfoSubid,
            });
          });
          this.snmpVersionList = snmpVersionList;
        });

      commonAPI
        .getBasicinfoSubList({
          basicinfoId: 'SNMPAUTH',
        })
        .then((res) => {
          const list = res.data.data;
          const snmpV3AuthList = [];
          list.forEach((data) => {
            snmpV3AuthList.push({
              label: data.basicinfoSubname,
              snmpV3AuthProtocol: data.basicinfoSubid,
            });
          });
          this.snmpV3AuthList = snmpV3AuthList;
        });

      commonAPI
        .getBasicinfoSubList({
          basicinfoId: 'SNMPPRIV',
        })
        .then((res) => {
          const list = res.data.data;
          const snmpV3PrivList = [];

          list.forEach((data) => {
            snmpV3PrivList.push({
              label: data.basicinfoSubname,
              snmpV3PrivProtocol: data.basicinfoSubid,
            });
          });
          this.snmpV3PrivList = snmpV3PrivList;
        });
      commonAPI.getMgrInfoList({}).then((res) => {
        this.managerList = res.data.data;
      });
      this.basicInfoLoadFlag = true;
    },
    /**
     * managerName 조회
     * @param  {[type]} managerId [description]
     * @return {[type]}           [description]
     * @author jda
     */
    getObjManagerName(managerId) {
      if (isEmpty(managerId)) {
        return EMPTY_TEXT;
      }
      const mgrInfo = this.managerList.find((data) => data.managerId === managerId);
      return isEmpty(mgrInfo) ? EMPTY_TEXT : mgrInfo.managerName;
    },
  },
};
</script>

<style>
.form-list .el-form-item__label {
  text-align: left;
}

.form-header {
  padding-left: 10px;
  height: 25px;
  font-weight: bold;
  font-size: 14px;
  color: $chinagray;
}
</style>



// WEBPACK FOOTER //
// src/views/config/node/server/configstatus/index.vue